import VocAudioPlayer from "./src/main"

/* istanbul ignore next */
VocAudioPlayer.install = function (Vue) {
  Vue.component(VocAudioPlayer.name, VocAudioPlayer)
}

export default VocAudioPlayer
